<template>
    <div class="border-b"
        :class="{'bg-brand-lightest': index % 2 !== 0}">
        <div class="flex flex-row justify-between items-center p-3">
            <div class="flex-1 min-w-0 truncate" :title="file.filename" @click="expand = !expand">{{ file.filename }}</div>
            <button type="button"
                class="ml-2 flex-none border border-grey bg-white text-grey-darker text-sm font-medium py-2 px-4 rounded"
                @click.prevent="expand = !expand">
                <span v-if="!expand"><i class="fa fa-expand text-brand mr-1"></i> Expand</span>
                <span v-else>Close <i class="fa fa-times ml-1"></i></span>
            </button>
        </div>

        <transition name="fade">
            <div v-if="expand" class="px-3 pb-3">
                <div class="w-full bg-grey-light p-3 rounded flex">
                    <div class="flex-1">
                        <p class="text-xxs uppercase tracking-wide text-grey-dark font-semibold">Uploaded</p>
                        <p class="mt-1">{{ date_uploaded }}</p>
                    </div>
                    <div class="flex-1 ml-2">
                        <p class="text-xxs uppercase tracking-wide text-grey-dark font-semibold">Type</p>
                        <p class="mt-1">{{ file_type }}</p>
                    </div>
                    <div class="flex-1 ml-2">
                        <p class="text-xxs uppercase tracking-wide text-grey-dark font-semibold">Size</p>
                        <p class="mt-1">{{ file_size }}</p>
                    </div>
                </div>
                <div class="w-full mt-3 flex">
                    <button type="button"
                        class="flex-1 border border-brand bg-brand text-white text-sm font-medium py-2 px-4 rounded"
                        @click.prevent="view">
                        <i class="fa fa-search mr-1"></i> View
                    </button>
                    <button type="button"
                        class="flex-1 ml-2 border border-green bg-white text-green text-sm font-medium py-2 px-4 rounded"
                        @click.prevent="archiveFileConfirm">
                        <i class="fa fa-archive mr-1"></i> Archive
                    </button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { fileTypeLabel, fileSizeLabel } from "../../file_labels.mjs";

export default {
    props :[ 'index', 'file' ],

    data() {
        return {
            expand: false,
        }
    },

    methods: {
        refileConfirm() {
            this.$emit('refile-confirm', this.file);
        },
        view() {
            this.$emit('view', this.file);
        },
        archiveFileConfirm() {
            this.$emit('archive-confirm', this.file);
        },
    },

    computed: {
        file_size() {
            return fileSizeLabel(this.file.size);
        },
        file_type() {
            return fileTypeLabel(this.file);
        },
        date_uploaded() {
            let this_date = moment(this.file.created_at);
			return this_date.format('DD/MM/YYYY');
        }
    }
}
</script>

<style>

</style>
